import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getPickupAddressSelector } from '../selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { PickupAddressConstants } from '../store/pickupAddress.constants'
import { IPickupAddressState } from '../store/pickupAddress.types'
import { setResponse } from '../store/pickupAddress.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* savePickupAddress() {
  const pickupAddress: IPickupAddressState = yield select(getPickupAddressSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient, pickupAddress } }
    try {
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setResponse(response))
    } catch (e) {
      yield put(throwPcrException(`savePickupAddress() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* savePickupAddressSaga() {
  yield takeLatest(
    [
      PickupAddressConstants.SET_TYPE,
      PickupAddressConstants.SET_OTHER_TYPE,
      PickupAddressConstants.SET_LOCATION,
      PickupAddressConstants.SET_COUNTY,
      PickupAddressConstants.SET_MCD,
      PickupAddressConstants.SET_REFERRING_MD,
      PickupAddressConstants.SET_REFERRING_RN,
      PickupAddressConstants.SET_REFERRING_USNG,
      PickupAddressConstants.SET_REFERRING_GPS_N,
      PickupAddressConstants.SET_REFERRING_GPS_E,
      PickupAddressConstants.SET_RESPONSE_MODE,
      PickupAddressConstants.SET_ADDRESS_LINE1,
      PickupAddressConstants.SET_ADDRESS_LINE2,
      PickupAddressConstants.SET_APT_SUITE_ROOM,
      PickupAddressConstants.SET_MILE_POST_MAJOR_ROADWAY,
      PickupAddressConstants.SET_CROSS_STREET_DIRECTIONS,
      PickupAddressConstants.SET_CITY,
      PickupAddressConstants.SET_STATE,
      PickupAddressConstants.SET_ZIP,
      PickupAddressConstants.SET_COUNTRY,
      PickupAddressConstants.SET_CENSUS_TRACT,
      PickupAddressConstants.SAVE_PICKUP_ADDRESS,
      PickupAddressConstants.SET_HOSPITAL_UNIT,
      PickupAddressConstants.SET_SCENE_GRID,
      PickupAddressConstants.SET_MODE_DESCRIPTORS,
      PickupAddressConstants.SET_PICKUP_ADDRESS_MODE_DESCRIPTORS_PNNV,
      PickupAddressConstants.SET_RFT,
      PickupAddressConstants.SET_REFERRING_MD_OTHER,
    ],
    performWithMutexHOG,
    savePickupAddress
  )
}
